export interface DefaultPackage {
    id: number;
    feature_name: string;
    category?: 'Others' | 'Building Control' | null;
    tab: string;
    key_name: string;
    display_name: string;
    status: 1 | 0;
    now_available: 1 | 0;
    show_shortcut: 1 | 0;
    icChecked: boolean,
}

export const mapDefaultPackage = (data: any): DefaultPackage => {
    if (!data) {
        throw new Error('Invalied DefaultPackage type')
    }

    const defaultPackage: DefaultPackage = {
        id: data.id,
        feature_name: data.feature_name,
        category: data.category,
        tab: data.tab,
        key_name: data.key_name,
        display_name: data.display_name,
        status: data.status,
        now_available: data.now_available,
        show_shortcut: data.show_shortcut,
        icChecked: false
    }

    return defaultPackage;
}

export const mapDefaultPackages = (data: any[]): DefaultPackage[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid DefaultPackage data');
    }

    return data.map(mapDefaultPackage);
};
